window.moment = require('moment');
window.momentTz = require('moment-timezone');
window.Vue = require('vue');
import VueResource from 'vue-resource';
import VueEvents from 'vue-events';
import Echo from 'laravel-echo';

Vue.use(VueResource);
Vue.use(VueEvents);
Vue.http.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');

// const broadcaster = process.env.MIX_ECHO_DRIVER || 'pusher';
// window.Pusher = require('pusher-js');
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     encrypted: process.env.MIX_PUSHER_ENCRYPTED === 'true',
//     forceTLS: process.env.MIX_PUSHER_ENCRYPTED === 'true',
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER
// });
//
// if (broadcaster === 'socket.io') {
//     window.io = require('socket.io-client');//Required 2.4.0
//     window.Echo = new Echo({
//         broadcaster,
//         transports: ['websocket', 'polling']
//     });
// }
